import React from 'react';
import { Layout, Error404, getAllSettings } from '@web-creditea/utils';

import { MARKET, REVALIDATION_TIME } from '../src/constants';
import { GetStaticPropsContext } from 'next';
import { createClient } from '../lib/apollo-client';

export const Custom404 = ({ settings }) => {
  const { notFoundPage } = settings;
  return (
    <Layout title={notFoundPage.title} settings={settings} mode={'light'}>
      <Error404 title={notFoundPage.title} text={notFoundPage.text} button={notFoundPage.button} />
    </Layout>
  );
};

export async function getStaticProps(props: GetStaticPropsContext) {
  const { locale, preview } = props;
  const language = locale.toUpperCase();
  const client = createClient();

  const settings = await getAllSettings(client, MARKET, language, preview);

  return {
    props: { settings },
    revalidate: REVALIDATION_TIME,
  };
}

export default Custom404;
